// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__1fxcX","menuItem":"Menu_menuItem__C4C9g","icon":"Menu_icon__5pL-p","optionsMenuText":"Menu_optionsMenuText__dAvPO"};